import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { Box, CircularProgress, styled } from '@mui/material';
var LoaderContainer = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 49%;\n  top: 50%;\n"])));
var StyledLoader = styled(CircularProgress)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    color: theme.colors.funGreen
  };
  return styles;
});
export { LoaderContainer, StyledLoader };